import React, { useState, useEffect } from 'react';
import './Header.css';
import logo from '../static/media/logo.jpg'; // Path to your logo image
import { Link } from 'react-router-dom'; // Import Link from react-router-dom


const Header = () => {
  const [logoSize, setLogoSize] = useState('large');

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setLogoSize('small');
      } else {
        setLogoSize('large');
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <header className="header">
      <nav className="navbar">
        <div className={`logo ${logoSize}`}>
          <img src={logo} alt="Jaikon Logo" />
        </div>
        <ul className="nav-links">
        <li><Link to="/">Home</Link></li>
          <li><Link to="/about-us">About</Link></li>
          <li><Link to="/services">Services</Link></li>
          <li><Link to="/contact">Contact</Link></li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;